import React from 'react'
import {
  Routes,
  Route,
  BrowserRouter as Router,
  useLocation,
  BrowserRouter
} from 'react-router-dom'
import routes from './route'
import { AuthProvider } from './context/logincontext'
import { SubscriptionProvider } from './context/subscriptionprovider'
import Navbar from './pages/layouts/navbar'
import './styles/main.css'
import { Tooltip as ReactTooltip } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'
import { StoreProvider } from './context/storecontext'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from './context/logincontext'
import Cookies from 'js-cookie'

function AppContent () {
  const location = useLocation()
  const navigate = useNavigate()
  const { userdata, logout } = useAuth()

  useEffect(() => {
    const token = Cookies.get('token')

    if (!token) {
      logout()
      return
    }
  }, [])

  useEffect(() => {
    const handleLogout = () => {
      navigate('/')
    }

    window.addEventListener('authLogout', handleLogout)

    return () => {
      window.removeEventListener('authLogout', handleLogout)
    }
  }, [navigate])

  // Routes where layout should be hidden
  const hideLayoutRoutes = [
    '/',
    '/register',
    '/forgot-password',
    '/reset-password',
    '/pages/terms-conditions',
    '/pages/privacy-policy',
    '/shopify/callback'
  ]
  const hideLayout = hideLayoutRoutes.includes(location.pathname)

  return (
    <div>
      {hideLayout ? (
        <Routes>
          {routes.map((route, index) => (
            <Route key={index} path={route.path} element={route.element} />
          ))}
        </Routes>
      ) : (
        <div className='relative font-Dmsans max-w-[1400px] mx-auto'>
          <div className='bg-linear-gradient 3xl:mt-[1%] 4xl:w-[1%]'></div>
          <div className='main-container'>
            <Navbar />
            <div className='working-area mt-5 pb-5 md:pb-0'>
              <Routes>
                {routes.map((route, index) => (
                  <Route
                    key={index}
                    path={route.path}
                    element={route.element}
                  />
                ))}
              </Routes>
            </div>
            <ReactTooltip
              id='my-tooltip'
              className='!bg-[#FFFFFF] !opacity-100 !text-black !text-sm !px-3 !py-2 !max-w-xs !rounded-md !inline-block !shadow-[0px_0px_5px_rgba(0,0,0,0.2)]  !bg-none'
            />
          </div>
        </div>
      )}
    </div>
  )
}

function App () {
  return (
    <BrowserRouter>
      <AuthProvider>
        <StoreProvider>
          <SubscriptionProvider>
            {' '}
            <AppContent />
          </SubscriptionProvider>
        </StoreProvider>
      </AuthProvider>
    </BrowserRouter>
  )
}

export default App
